

import umd from './components/UMD';

import {HelpersAllTap} from './components/helpers';

import * as index from './components/classes/index';

umd(function (window, isGlobal) {
    if (!isGlobal) {
        window.AllTap = HelpersAllTap({})({window: window});
        window.StageClass = index;
    }
});
